import { Component, OnInit, Input, AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ToasterMessage } from '../../../api/models/toaster';
import { FormGroup } from '@angular/forms';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeInOut', [
        transition(':enter', [
            style({opacity: 0}),
            animate(300, style({opacity: 1}))
        ]),
        transition(':leave', [
            animate(300, style({opacity: 0}))
        ])
    ])
  ]
})
export class ToasterComponent implements OnInit, AfterContentChecked {

  @Input() toasterMessage: ToasterMessage;
  @Input() bgStyle: string;

  constructor(
      private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
  }

  ngAfterContentChecked() {
      /**
       * This function hides existing
       * error message after 5 secs
       */
      if (this.toasterMessage.show === true) {
          const timeout = setTimeout(() => {
              this.cd.markForCheck();
              this.toasterMessage = {
                  show:  false
              };
              clearTimeout(timeout);
          }, (this.toasterMessage.timeout === undefined) ?  4000 : this.toasterMessage.timeout);
      }

  }

  // /**
  //  * This function hides existing
  //  * error message if form becomes valid
  //  */
  // hideMessageOnValidForm(): void {
  //     if (this.form) {
  //         this.form.statusChanges.subscribe(status => {
  //             if (status === 'VALID') {
  //                 this.toastermessage.show = false;
  //             }
  //         });
  //     }
  // }

  closeModal() {
      this.toasterMessage.show = false;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/toaster/toaster.component.ts